// extracted by mini-css-extract-plugin
export default {"segmentedButtons":"SegmentedButtons_segmentedButtons__DRGUR","button":"SegmentedButtons_button__wy3GW"};